// 年度の開始年月を取得
export function getNendoStartMonth(td) {
  td = td ?? new Date();
  // 1月、2月の場合は年度は前年の３月から
  if (td.getMonth() < 2) {
    return `${td.getFullYear() - 1}/03`;
  }
  return `${td.getFullYear()}/03`;
}

// 年度の終了年月を取得
export function getNendoEndMonth(td) {
  td = td ?? new Date();
  // 1月、2月の場合は年度は今年の２月まで
  if (td.getMonth() < 2) {
    return `${td.getFullYear()}/02`;
  }
  return `${td.getFullYear() + 1}/02`;
}

// 対象年月が過去の年月かどうか判定
export function isPastYearMonth(dateString) {
  // 文字列を日付オブジェクトにパース
  const dateObj = new Date(dateString);

  // 現在の年月を取得
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  // 年月を比較して過去の年月かどうかを判定
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth();
  const isPast = year < currentYear || (year === currentYear && month < currentMonth);

  return isPast;
}

// 前の月の1日を取得
export function getFirstDayOfLastMonth(targetDate) {
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth();

  // 月が0（1月）なら前年の12月にする
  const firstDayOfLastMonth = new Date(year, month - 1, 1);

  return firstDayOfLastMonth;
}

// 前の月の1日を取得
export function getLastDayOfThisMonth(targetDate) {
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1; // 翌月の1日の前日が今月の末日

  // 翌月の1日の前日を取得
  const lastDayOfThisMonth = new Date(year, month, 0);

  return lastDayOfThisMonth;
}

// 今月の1日を取得
export function getFirstDayOfThisMonth(targetDate) {
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth();
  return new Date(year, month, 1);
}

// 来月の末日を取得
export function getLastDayOfNextMonth(targetDate) {
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 2; // 再来月の1日を指定
  const firstDayOfFollowingMonth = new Date(year, month, 1);
  const lastDayOfNextMonth = new Date(firstDayOfFollowingMonth - 1); // 1日前に戻る
  lastDayOfNextMonth.setHours(23, 59, 59, 999);
  return lastDayOfNextMonth;
}

// 今期を取得
export function getCurrentPeriod(_targetDate=null) {
  const basePeriod = 51;
  const baseYear = 2023;

  let targetDate = toDate(_targetDate);
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1; // JavaScript は 0-11 月

  // 7月以降は当年の期、それ以前は前年の期
  const period = month >= 7 ? basePeriod + (year - baseYear) : basePeriod + (year - baseYear) - 1;

  return period;
}

// 期のリストを取得
export function getPeriods() {
  const periods = [];
  const startPeriod = 51; // 51期が開始
  const endPeriod = getCurrentPeriod() + 1; // 現在の期の次の期までを取得
  for (let i = startPeriod; i <= endPeriod; i++) {
    periods.push(i);
  }
  return periods;
}

// 今月より前の月かどうか判定
export function isBeforeThisMonth(month, preriod) {
  // 今月より前と判断
  if (getCurrentPeriod() !== parseInt(preriod)) {
    return true;
  }

  let thisMonth = new Date().getMonth() + 1;
  const targetMonth = parseInt(month.match(/\d+/)[0]);
  return thisMonth >= 7
    ? targetMonth >= 7 && targetMonth <= thisMonth
    : targetMonth >= 7 || targetMonth <= thisMonth;
}

/// 文字列を日付に変換
export function toDate(strDate)
{
  // 未指定は現在日付を返す
  if (!strDate) return new Date();

  // 日付型の場合はそのまま返す
  if (strDate instanceof Date) {
    return strDate;
  }

  const date = new Date(strDate);
  return isNaN(date) ? null : date;
}